export const providersPage = {
  drawer: {
    monitoringProvidersTitle: 'Monitoring Providers',
    careProvidersTitle: 'Care Providers',
    assignProvidersLabel: 'Assign Providers'
  },
  patientProfile: {
    requiredFieldsMessage: 'Please fill in required fields: Contact Preference'
  },
  index: {
    administrationHeading: 'Administration',
    patientDetailsLabel: 'Patient Details'
  },
  doNotCallPreference: {
    label: 'Do Not Call or Follow Up',
    specifiedOnPrefix: 'Specified on:'
  },
  guarantorForm: {
    heading: 'Guarantor Information',
    firstNameLabel: 'First Name',
    dateOfBirthLabel: 'Date of Birth',
    middleNameLabel: 'Middle Name',
    phoneLabel: 'Phone',
    lastNameLabel: 'Last Name',
    sameAsPatientAddressLabel: 'Same as patient address',
    sameAsCompanyAddressLabel: 'Same as pharmacy address',
    addressLine1Label: 'Address Line 1',
    addressLine2Label: 'Address Line 2',
    cityLabel: 'City',
    stateLabel: 'State',
    statePlaceholder: 'State',
    zipcodeLabel: 'Zipcode',
    missingAddressFieldsMessage: (fields: string) => `Please fill in required guarantor address fields: ${fields}`,
    missingPatientAddressFieldsMessage: (fields: string) =>
      `The patient address is missing: ${fields}. Complete the patient address or uncheck "Same as patient address".`,
    missingCompanyAddressFieldsMessage: (fields: string) =>
      `The pharmacy address on file is missing: ${fields}. Ask an admin to complete it in Company Setup, then reload this page. Or uncheck "Same as pharmacy address" and enter the guarantor address.`,
    emergencyContactLabel: 'Emergency contact',
    accessMedicalRecordsLabel: 'Can access medical records'
  },
  insuranceProfileForm: {
    addDemographicProfileLabel: 'Add Demographic Profile',
    languageLabel: 'Language',
    raceLabel: 'Race',
    ethnicityLabel: 'Ethnicity',
    maritalStatusLabel: 'Marital Status',
    usualProviderLabel: 'Usual Provider',
    homePhoneLabel: 'Home Phone',
    contactPreferenceLabel: 'Contact Preference',
    guarantorRelationshipLabel: 'Guarantor Relationship'
  },
  manage: {
    portalOrgsTitle: 'Portal Orgs',
    moveToRightLabel: 'Move to Right',
    moveToLeftLabel: 'Move to Left',
    saveLabel: 'Save'
  },
  insurancePlans: {
    heading: 'Patient Insurance Plans'
  },
  clientOrgAndStore: {
    heading: 'Client Organizations and Stores'
  },
  profileForm: {
    firstNameLabel: 'First Name',
    dateOfBirthLabel: 'Date of Birth',
    middleNameLabel: 'Middle Name',
    genderLabel: 'Gender',
    lastNameLabel: 'Last Name',
    phoneLabel: 'Phone',
    addressLine1Label: 'Address Line 1',
    addressLine2Label: 'Address Line 2',
    addressCityLabel: 'Address City',
    zipcodeLabel: 'Zipcode',
    addressStateLabel: 'Address State',
    healthPlanLabel: 'Health Plan',
    relationshipToGuarantorLabel: "Patient's Relationship to Guarantor",
    languageLabel: 'Language',
    ehrIdLabel: 'EHR ID',
    mtmCaseNumberLabel: 'MTM Case Number'
  },
  providerCard: {
    pcpChip: 'PCP',
    monitoringChip: 'Monitoring',
    nameLabel: 'Name',
    npiNumberLabel: 'NPI Number',
    emailLabel: 'Email',
    faxLabel: 'Fax',
    phoneNumberLabel: 'Phone Number'
  }
} as const;
